import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_svg(`<svg></svg>`);

export default function Icon($$anchor, $$props) {
	let size = $.prop($$props, 'size', 3, 24),
		color = $.prop($$props, 'color', 3, 'currentColor'),
		strokeWidth = $.prop($$props, 'strokeWidth', 3, 2),
		className = $.prop($$props, 'class', 3, ''),
		iconNode = $.prop($$props, 'iconNode', 19, () => []),
		rest = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'size',
			'color',
			'strokeWidth',
			'class',
			'iconNode'
		]);

	var svg = root();

	$.attribute_effect(svg, () => ({
		xmlns: 'http://www.w3.org/2000/svg',
		width: size(),
		height: size(),
		viewBox: '0 0 24 24',
		fill: 'none',
		stroke: color(),
		'stroke-width': strokeWidth(),
		'stroke-linecap': 'round',
		'stroke-linejoin': 'round',
		'aria-hidden': 'true',
		class: className(),
		...rest
	}));

	$.each(svg, 21, iconNode, $.index, ($$anchor, $$item) => {
		var $$array = $.derived(() => $.to_array($.get($$item), 2));
		let tag = () => $.get($$array)[0];
		let attrs = () => $.get($$array)[1];
		var fragment = $.comment();
		var node = $.first_child(fragment);

		$.element(node, tag, true, ($$element, $$anchor) => {
			$.attribute_effect($$element, () => ({ ...attrs() }));
		});

		$.append($$anchor, fragment);
	});

	$.reset(svg);
	$.append($$anchor, svg);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiSWNvbi5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgbGV0IHsgc2l6ZSA9IDI0LCBjb2xvciA9ICdjdXJyZW50Q29sb3InLCBzdHJva2VXaWR0aCA9IDIsIGNsYXNzOiBjbGFzc05hbWUgPSAnJywgaWNvbk5vZGUgPSBbXSwgLi4ucmVzdCB9OiB7XG4gICAgc2l6ZT86IG51bWJlcjtcbiAgICBjb2xvcj86IHN0cmluZztcbiAgICBzdHJva2VXaWR0aD86IG51bWJlcjtcbiAgICBjbGFzcz86IHN0cmluZztcbiAgICBpY29uTm9kZT86IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW107XG4gICAgW2tleTogc3RyaW5nXTogdW5rbm93bjtcbiAgfSA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48c3ZnXG4gIHhtbG5zPVwiaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmdcIlxuICB3aWR0aD17c2l6ZX1cbiAgaGVpZ2h0PXtzaXplfVxuICB2aWV3Qm94PVwiMCAwIDI0IDI0XCJcbiAgZmlsbD1cIm5vbmVcIlxuICBzdHJva2U9e2NvbG9yfVxuICBzdHJva2Utd2lkdGg9e3N0cm9rZVdpZHRofVxuICBzdHJva2UtbGluZWNhcD1cInJvdW5kXCJcbiAgc3Ryb2tlLWxpbmVqb2luPVwicm91bmRcIlxuICBhcmlhLWhpZGRlbj1cInRydWVcIlxuICBjbGFzcz17Y2xhc3NOYW1lfVxuICB7Li4ucmVzdH1cbj5cbiAgeyNlYWNoIGljb25Ob2RlIGFzIFt0YWcsIGF0dHJzXX1cbiAgICA8c3ZlbHRlOmVsZW1lbnQgdGhpcz17dGFnfSB7Li4uYXR0cnN9Lz5cbiAgey9lYWNofVxuPC9zdmc+XG4iXSwibWFwcGluZ3MiOiI7Ozs7O2dEQUFBLENBQUM7S0FDTyxJQUFJLDhCQUFHLEVBQUU7RUFBRSxLQUFLLCtCQUFHLGNBQWM7RUFBRSxXQUFXLHFDQUFHLENBQUM7RUFBUyxTQUFTLCtCQUFHLEVBQUU7RUFBRSxRQUFRO0VBQVUsSUFBSTs7Ozs7Ozs7Ozs7Ozs7O1NBV2hHLElBQUk7VUFDSCxJQUFJOzs7VUFHSixLQUFLO2tCQUNDLFdBQVc7Ozs7U0FJbEIsU0FBUztLQUNaLElBQUk7OztpQkFFRCxRQUFROztNQUFNLEdBQUc7TUFBRSxLQUFLOzs7O2tCQUNQLEdBQUc7NkNBQU0sS0FBSzs7Ozs7Ozs7QUFoQnpDLENBQUMifQ==